import { Component, input } from '@angular/core';
import { InitialsPipe } from '../../../../shared/pipes/initials.pipe';

@Component({
  selector: 'app-parent-ai-user-meta-row',
  standalone: true,
  imports: [InitialsPipe],
  templateUrl: './parent-ai-user-meta-row.component.html',
  styleUrl: './parent-ai-user-meta-row.component.scss',
})
export class ParentAiUserMetaRowComponent {
  displayName = input.required<string>();
  avatarUrl = input<string | null>(null);
  initialsSource = input<{ firstName?: string; lastName?: string } | null>(null);

  protected fallbackLetter(): string {
    const n = this.displayName().trim();
    return n ? n[0]!.toUpperCase() : '?';
  }
}
